import { memoize } from 'redux-memoize';

export const rememoize = (opts, fn, params) => memoize(opts, fn.unmemoized)(params);

export const rememoize5min = (fn, params) => rememoize({ ttl: 300000 }, fn, params);

export const shortMemoize = (fn) => memoize({ ttl: 1000 }, fn.unmemoized);
